import { atom } from "recoil";
import { AssetSort } from "../services";

export const AssetSortState = atom<AssetSort>({
  key: "assetSortState",
  default: AssetSort.FileName,
});
